import { PaymentGateway, GatewayConfig } from "./types";
import { paymentGateway } from "../../../config";

/**
 * Configuration for each supported payment gateway
 */
export const GATEWAY_CONFIGS: Record<PaymentGateway, GatewayConfig> = {
  bpoint: {
    scriptUrl: "https://www.bpoint.com.au/webapi/CBA/api.js?v=3",
    name: "BPOINT",
  },
  sawfish: {
    scriptUrl: null, // To be configured when Sawfish integration is implemented
    name: "Sawfish",
  },
};

/**
 * Get the current payment gateway from environment variable
 * Falls back to "bpoint" if not set or invalid
 */
export function getCurrentGateway(): PaymentGateway {
  // Validate that the gateway exists in our config
  if (paymentGateway in GATEWAY_CONFIGS) {
    return paymentGateway as PaymentGateway;
  }

  // Default to bpoint
  return "bpoint";
}

/**
 * Get the configuration for a specific gateway
 */
export function getGatewayConfig(gateway: PaymentGateway): GatewayConfig {
  return GATEWAY_CONFIGS[gateway];
}
